window.filterPreviousState = {
    type: '',
    brands: [],
    currencies: [],
    regions: [],
    search: '',
    page: '',
};
window.filterPreviousStates = [];

window.filter = function filter() {
    return {
        showFilters: false,
        type: '',
        brands: [],
        currencies: [],
        regions: [],
        search: '',
        page: '',
        _nt: null,
        state: {},
        saveState: true,
        focusElement: null,

        initFunction(state, $nextTick) {
            this._nt = $nextTick;
            this.setFromState(state);

            // Using window variables to avoid alpine proxying all the data
            window.addEventListener('saveFilterState', (ev) => {
                window.filterPreviousStates.push(window.filterPreviousState);
                window.filterPreviousState = ev.detail;
            });

            window.addEventListener('popstate', (e) => {
                if (window.filterPreviousStates.length) {
                    const filterPreviousState = window.filterPreviousStates.pop();
                    e.preventDefault();
                    this.setFromState(filterPreviousState);
                    this.saveState = false;
                    this.refresh();
                }
            });

            htmx.on('htmx:afterSwap', (event) => {
                if (event.detail.target.getAttribute('id') == 'filter') {
                    this._nt(() => {
                        const el = this.focusElement ? document.querySelector(`#${this.focusElement}`) : null;
                        // Re-focus the element that made the call.
                        if (el) {
                            el.focus();
                            this.focusElement = null;
                        }
                    });
                }
            });
        },

        setFromState(state) {
            this.type = state.type;
            this.brands = state.brands;
            this.currencies = state.currencies;
            this.regions = state.regions;
            this.search = state.search;
            this.page = state.page;
        },

        toggle(key, value) {
            const idx = this[key].indexOf(value);
            if (idx == -1) {
                this[key].push(value);
            } else if (this[key].length == 1) {
                    this[key] = [];
            } else {
                delete this[key][idx];
            }

            this[key] = this[key].flat();

            this.refresh();
        },

        clear() {
            this.brands = [];
            this.currencies = [];
            this.regions = [];
            this.search = '';
            this.page = 1;

            this.refresh();
        },

        setType(val, $event) {
            const el = $event.target || $event.srcElement;

            this.focusElement = el.id;
            this.type = val == this.type ? '' : val;
            this.search = '';

            this.refresh();
        },

        refresh() {
            // always hide mobile filter list when selecting a filter
            this.showFilters = false;

            if (this.search) {
                this.type = '';
            }

            this._nt(() => {
                htmx.trigger(htmx.find('#filter'), 'refresh');
            });
        }
    };
};
